import styled from 'styled-components'

export const RootContainer = styled.div`
  width: 100%;
  min-height: 600px;
  display: flex;
  flex-direction: column;
`

export const ChartContainer = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 12px;
  min-height: 500px;
  min-width: 200px;
`

export const ChartWrapper = styled.div`
  position: relative;
  flex: 1;
  min-height: 500px;
  min-width: 200px;
`

export const NowWrapper = styled.div`
  position: absolute;
  top: 9px;
  left: 10px;
`

export const StyledLegend = styled.ul`
  font-size: 14px;
  list-style-type: none;
  padding: 20px 10px 10px 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 450px;
`

export const StyledHeader = styled.strong`
  //margin-left: 30px;
  //font-size: 1.3em;
  word-spacing: 6px;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`

export const StyledCell = styled.div`
  width: 35px;
  text-align: center;
`

export const LegendItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 9;
`

export const LegendItem = styled.li`
  display: flex;
  align-items: center;
  //  justify-content: center;
  margin-bottom: 20px;
  // flex: 1;
  flex-direction: row;
`

export const TimeScaleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 50px;
  width: 100%;
`

export const PatientDetailsWrapper = styled.div`
  width: 15%;
  padding: 10px 10px 10px 20px;
  font-size: 14px;
`

export const MessageContainer = styled.div`
  height: 500px;
  width: 100%;
  display: flex;
  padding-top: 100px;
  align-items: flex-start;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
`
export const RangePickerContainer = styled.div`
  width: 45%;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  padding: 40px 0 20px 0;
  gap: 10px;
`

export const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  left: calc(50% - 200px);
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
  padding: 10px;
`

export const StyledButton = styled.button<{ isActive: boolean, disabled: boolean }>`
  width: 200px;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  background: ${(props) => (props.disabled ? "#d5d5d5" : props.isActive ? '#2563eb' : '#ffffff')};
  color: ${(props) => (props.isActive ? '#ffffff' : '#64748b')};

  &:hover {
    background: ${(props) => (props.disabled ? "#d5d5d5" : props.isActive ? '#1d4ed8' : '#f8fafc')};
  }

  &:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`

export const DisabledOverlay = styled.div<{
  left: string
  width: string
  height: string
}>`
  position: absolute;

  left: ${(props) => props.left};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  background-color: rgba(251, 251, 251, 0.7);
  pointer-events: 'none';
  z-index: 10;
  display: 'block'};
`